import React from 'react'
import { t } from '@lingui/core/macro'
import MainButton from '../MainButton/MainButton'
import styles from './SubmitButton.module.css'

const SubmitButton = ({ isSubmitting }: { isSubmitting: boolean }) => (
    <MainButton
        message={isSubmitting ? t`Обработка...` : t`Оплатить`}
        type="submit" onClick={() => {}}
        disabled={isSubmitting}
        className={styles.submitButton}
    />
)

export default SubmitButton
